import { useEffect, useState } from "react";

/**
 * Watches the DOM for any open Radix UI dialog (role="dialog" with
 * data-state="open"). Used by floating overlays (chat widget, help
 * button) to hide themselves while a modal is open so they don't
 * cover critical modal content.
 *
 * Cheap: single MutationObserver scoped to body attributes + subtree
 * childList — Radix portals dialog nodes as direct children of body
 * and toggles data-state on them.
 */
export default function useAnyDialogOpen() {
  const [anyOpen, setAnyOpen] = useState(false);

  useEffect(() => {
    const check = () => {
      const el = document.querySelector(
        '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]'
      );
      setAnyOpen(!!el);
    };
    check();
    const obs = new MutationObserver(check);
    obs.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["data-state", "role"],
    });
    return () => obs.disconnect();
  }, []);

  return anyOpen;
}
